import { z } from 'zod/v4'

export const loginSchema = z.object({
  email: z.email('Invalid email format'),
  password: z.string().trim().min(8, 'Password must be at least 8 characters'),
})

export const signUpSchema = z.object({
  name: z.string().trim().min(3, 'Name must be at least 3 characters'),
  email: z.email('Invalid email format'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  password_confirmation: z.string(),
})
export const forgotPasswordSchema = z.object({
  email: z.email('Invalid email format'),
})

export const resetPasswordSchema = z.object({
  email: z.email('Invalid email format'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  password_confirmation: z.string(),
  token: z
    .string({ message: 'A valid reset token is required' })
    .trim()
    .regex(/^[A-Fa-f0-9]{64}$/, 'Invalid reset token'),
})

export type LoginValues = z.infer<typeof loginSchema>
export type SignUpValues = z.infer<typeof signUpSchema>
export type ForgotPasswordValues = z.infer<typeof forgotPasswordSchema>
export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>
